import forecastActions, { forecastActionTypes } from '@Actions/application/forecastActions';

const ForecastReducers = (state = {}, action) => {
  switch (action.type) {
  case forecastActionTypes.CREATE_FORECAST.LOADING: {
    const { createForecastLoading } = action;
    return {
      ...state,
      createForecastLoading,
    };
  }
  case forecastActionTypes.GET_FORECAST_LIST.LOADING: {
    const { getForecastListLoading } = action;
    return {
      ...state,
      getForecastListLoading,
    };
  }
  case forecastActionTypes.START_FORECAST.LOADING: {
    const { startForecastLoading } = action;
    return {
      ...state,
      startForecastLoading,
    };
  }
  case forecastActionTypes.GET_FORECAST_LIST.SUCCESS: {
    const { forecasts } = action;
    return {
      ...state,
      forecasts,
    };
  }
  case forecastActionTypes.GET_FORECAST_BY_ID.LOADING: {
    const { getForecastByIdLoading } = action;
    return {
      ...state,
      getForecastByIdLoading,
    };
  }
  case forecastActionTypes.GET_FORECAST_BY_ID.SUCCESS: {
    const { selectedForecast } = action;
    return {
      ...state,
      selectedForecast,
    };
  }
  case forecastActionTypes.GET_FORECAST_RESULTS.LOADING: {
    const { getForecastResultsLoading } = action;
    return {
      ...state,
      getForecastResultsLoading,
    };
  }
  case forecastActionTypes.GET_FORECAST_RESULTS.SUCCESS: {
    const { forecastResults } = action;
    return {
      ...state,
      forecastResults,
    };
  }
  case forecastActionTypes.DOWNLOAD_FORECAST.LOADING: {
    const { downloadForecastLoading } = action;
    return {
      ...state,
      downloadForecastLoading,
    };
  }
  default: {
    return state;
  }
  }
};

export default ForecastReducers;
